import {Box, Button, Flex, Heading, HStack, Menu, MenuButton, MenuItem, MenuList, Text} from "@chakra-ui/react";
import styles from "../../login/styles";
import React from "react";
import {ReactComponent as Verifed} from "../../../../assets/icons/check-verified-02.svg";
import {ReactComponent as Shield} from "../../../../assets/icons/shield-zap.svg";
import {ReactComponent as Subtract} from "../../../../assets/icons/SubtractIcon.svg";
import {ReactComponent as Users} from "../../../../assets/icons/users-03.svg";
import {ReactComponent as Checked} from "../../../../assets/icons/check-circle.svg";
import {ReactComponent as LanguageIcon} from "../../../../assets/icons/language_icon_dark.svg";

export const SuperList = ({isMobile}) => {
    return (
        <Flex
            flexDirection={'column'}
            w={{base : '90%',  md: '379px', lg: '379px'}}
            m={isMobile ? '0' : 'auto'}
            gap={isMobile ? '16px':'32px'}>
            <Flex
                flexDirection={'column'}
                gap={'16px'}
                mb={isMobile ? '28px': '48px'}>
                <HStack>
                    <Subtract width={isMobile ? '16px' : '24px'} height={isMobile ? '16px' : '24px'}/>
                    <Heading
                        color={'white'}
                        fontSize={{base : 'heading.lg', md : 'heading.2xl', lg: 'heading.2xl'}}>
                        Superlist
                    </Heading>
                </HStack>
                <Heading
                    color={'white'}
                    fontSize={{base : 'heading.2xl', md : 'heading.2xl', lg: 'heading.5xl'}}>
                    Start your 30-day free trial
                </Heading>
                <HStack>
                    <Checked/>
                    <Text color={'#8996A9'} fontSize={{base : 'body.xs', md : 'body.xs', lg: 'body.md'}}>No credit card required</Text>
                </HStack>
            </Flex>
            <Box>
                <Users width={isMobile ? '20px' : '24px'} height={isMobile ? '20px' : '24px'}/>
                <Heading
                    mt={'12px'}
                    mb={'8px'}
                    color={'white'}
                    fontSize={{base : 'body.xs', md : 'body.xs', lg: 'body.md'}}>
                    Invite unlimited colleagues
                </Heading>
                <Text fontSize={{base : 'body.xs', md : 'body.xs', lg: 'body.md'}} color={'#8996A9'}>
                    Integrate with guaranteed developer-friendly APIs or openly to choose a
                    build-ready or low-code solution.
                </Text>
            </Box>
            <Box>
                <Verifed width={isMobile ? '20px' : '24px'} height={isMobile ? '20px' : '24px'}/>
                <Heading
                    mt={'12px'}
                    mb={'8px'}
                    color={'white'}
                    fontSize={{base : 'body.xs', md : 'body.xs', lg: 'body.md'}}>
                    Ensure compliance
                </Heading>
                <Text fontSize={{base : 'body.xs', md : 'body.xs', lg: 'body.md'}} color={'#8996A9'}>
                    Receive detailed insights on all your numbers in real-time,
                    see where visitors are coming from.
                </Text>
            </Box>
            <Box>
                <Shield width={isMobile ? '20px' : '24px'} height={isMobile ? '20px' : '24px'}/>
                <Heading
                    mt={'12px'}
                    mb={'8px'}
                    color={'white'}
                    fontSize={{base : 'body.xs', md : 'body.xs', lg: 'body.md'}}
                >
                    Built-in security
                </Heading>
                <Text fontSize={{base : 'body.xs', md : 'body.xs', lg: 'body.md'}} color={'#8996A9'}>
                    Keep your team members and customers in the loop by sharing your dashboard
                    public.
                </Text>
            </Box>
            <HStack>
                <Flex css={styles.terms} fontSize={isMobile ? 'body.xs': 'body.md'}>
                    <Text>Terms</Text>
                    <Text>Privacy</Text>
                    <Text>Docs</Text>
                    <Text>Helps</Text>
                </Flex>
                <Menu>
                    <MenuButton
                        _hover={''}
                        _active={''}
                        bg={'transparent'}
                        fontSize={isMobile ? 'body.xs': 'body.lg'}
                        color={'#8996A9'}
                        as={Button}
                        leftIcon={<LanguageIcon/>}>
                        EN
                    </MenuButton>
                    <MenuList>
                        <MenuItem value="en">EN</MenuItem>
                        <MenuItem value="ru">RU</MenuItem>
                    </MenuList>
                </Menu>
            </HStack>
        </Flex>
    )
}